import Vue from 'vue'
import Ripple from 'vue-ripple-directive'

Vue.directive('ripple', Ripple);
